module.exports = __webpack_public_path__ + "img/8.bb8165f4.webp";